import React, { useCallback, useMemo } from 'react';
import NameEditComponent from "engage/components/NameEditComponent/NameEditComponent";
import styles from "./GeneratedScenesHeader.module.scss";
import { CustomButton } from "engage/components/Button/Button";
import { useStoryboardContext } from "engage/context/StoryboardContext";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useTranslation } from "react-i18next";
import cx from 'classnames';
import { useUserContext } from 'engage/context/UserContext';

export const GeneratedScenesHeader = ({
  isEditingOptionsEnabled,
  comparisonMode,
  style,
}) => {
  const { videoId, projectName, updateProjectName, userPermissions, scenes, completeUserAssignments } = useStoryboardContext();
  const { user } = useUserContext();
  const { t } = useTranslation();

  const history = useHistory();

  const allowComplete = useMemo(() => {
    if (!userPermissions?.updateStory || userPermissions?.allowedScenes?.length > 0) {
      return scenes.filter(item => Boolean(item.author) && item?.author?.username === user.username).every(item => item.video !== null || item.processing);
    }
    return true;
  }, [userPermissions, scenes]);

  const redirect = useCallback(() => {
    const redirectPath = userPermissions.isOwner || userPermissions.updateStory ? `/eg/video/${videoId}` : `/eg/home`;
    if (!userPermissions.updateStory || userPermissions.allowedScenes.length > 0) {
      completeUserAssignments();
    }
    history.push(redirectPath);
  }, [userPermissions]);



  return (<header style={style} className={cx(styles.header)}>
    <div className={styles.section}>
      <div className={cx(styles.nameContainer)}>
        <NameEditComponent
          size="small"
          name={projectName}
          handleSaveName={updateProjectName}
          disableEditing={comparisonMode || !isEditingOptionsEnabled}
          isEditIcon={true}
        />
      </div>
    </div>
    <CustomButton
      label={t('general.done')}
      variant="basic"
      className={styles.doneBtn}
      disabled={!allowComplete}
      onClick={redirect}
    />
  </header>);
}